import './LoadingSpinner.css'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  className?: string
}

const LoadingSpinner = ({ size = 'medium', className = '' }: LoadingSpinnerProps) => {
  return (
    <div className={`loading-spinner loading-spinner-${size} ${className}`} aria-label="Loading">
      <div className="spinner"></div>
    </div>
  )
}

export default LoadingSpinner 